export const XXX = (state, getters) => (code) => {
  const status = getters.printerapiStatusInfo(code)
  return status?.name
}
